import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 admin_create_tenant: { message: "idle" },
};

export const admin_create_tenant_Slice = createSlice({
 name: "admin_create_tenant",
 initialState,
 reducers: {
  success_admin_create_tenant: (state, action) => {
   state.admin_create_tenant = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_admin_create_tenant: (state, action) => {
   state.admin_create_tenant = { status: app_consts.FAIL, message: action.payload };
  },
  reset_admin_create_tenant: (state) => {
   state.admin_create_tenant = { status: app_consts.IDLE };
  },
  loading_admin_create_tenant: (state) => {
   state.admin_create_tenant = { status: app_consts.LOADING };
  },
 }
});

export const { success_admin_create_tenant, fail_admin_create_tenant, reset_admin_create_tenant, loading_admin_create_tenant } = admin_create_tenant_Slice.actions;

export default admin_create_tenant_Slice.reducer;